import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { eTenderingDefinitionComponent } from './eTenderingDefinition.component';
import { DossierDetailModule } from '../components/dossierDetail.module';
import { DossierHeaderModule } from '../components/dossierHeader.module';

import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { TranslateModule } from '@ngx-translate/core';
import { dossierBasicInfoComponent } from '../components/dossierBasicInfo.component';
import { TenderingCommittesComponent } from './tenderingCommittes.component';
import { TableModule } from 'primeng-lts/table';
import { TenderingEnvelopesComponent } from './tenderingEnvelopes.component';
import { TenderingPhasesComponent } from './tenderingPhases.component';
import { TenderingPhaseEventComponent } from './tenderingPhaseEvent.component';
import { DialogService, DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { TenderingAwardCriteriaComponent } from './tenderingAwardCriteria.component';
import { DirectivesModule } from '../../directives/directives.module';
import { ValidationModule } from '../../components/common/validation/validation.module';
import { ButtonModule } from 'primeng-lts/button';
import { ConfirmDialogModule } from 'primeng-lts/confirmdialog';
import { DialogModule } from 'primeng-lts/dialog';
import { DropdownModule } from 'primeng-lts/dropdown';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TabViewModule } from 'primeng-lts/tabview';
import { TooltipModule } from 'primeng-lts/tooltip';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { CheckboxModule } from 'primeng-lts/checkbox';

@NgModule({
  declarations: [
    eTenderingDefinitionComponent,
    TenderingCommittesComponent,
    TenderingEnvelopesComponent,
    TenderingAwardCriteriaComponent,
    TenderingPhasesComponent,
    TenderingPhaseEventComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    DossierHeaderModule,
    DossierDetailModule,

    TableModule,
    TooltipModule,
    TabViewModule,
    PanelModule,
    ButtonModule,
    DropdownModule,
    TranslateModule,
    WaitLoadingModule,
    DynamicDialogModule,
    DirectivesModule,
    DialogModule,
    ScrollPanelModule,
    ValidationModule,
    SubHeaderModule,
    CheckboxModule,
    ConfirmDialogModule
  ],
  providers: [DialogService],
  entryComponents: [dossierBasicInfoComponent]
})
export class ETenderingDefinitionModule { }
